.mobile {
  display: inline;

  @media (min-width: 400px) {
    display: none;
  }
}

.desktop {
  display: none;

  @media (min-width: 400px) {
    display: inline;
  }
}

.signUp {
  display: flex;
  flex-direction: column;
  width: 100%;

  &.flat {
    .fields {
      padding: 0;
      border: none;
      border-radius: 0;
      background-color: transparent;
    }

    .disclaimer {
      font-size: 0.875rem;
    }
  }

  .fields {
    width: 100%;
    padding: 1.5rem 1.625rem;
    border: 0.0625rem solid var(--neutral-200);
    border-radius: 1.8125rem;
    background-color: var(--neutral);

    .input {
      margin: 0 0 1.3125rem;
    }

    .emailTaken {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin: -0.8125rem 0 -0.5rem;

      svg {
        flex: 0 0 auto;
        width: 1.125rem;
        height: 1.125rem;
        margin: 0 0.25rem 0 0;

        @media (min-width: 400px) {
          width: 1.25rem;
          height: 1.25rem;
          margin: 0 0.3125rem 0 0;
        }
      }

      .link {
        align-self: center;
        width: auto;
        height: 1.3125rem;
        margin-top: 0;
        margin-left: 0.1875rem;

        @media (min-width: 400px) {
          height: 1.5rem;
          margin-left: 0.25rem;
        }
      }
    }

    .password {
      position: relative;
      margin-top: 1.5rem;
      margin-bottom: 1rem;

      .requirement,
      .strength {
        position: absolute;
        top: -0.25rem;
        right: 0;
      }

      .input {
        width: 100%;
        margin-bottom: 0.625rem;

        input {
          padding-right: 2.875rem;
        }
      }

      .passwordReveal {
        position: absolute;
        top: 1.875rem;
        right: 0.25rem;
        width: 2.375rem;
        height: 2.375rem;

        @media (min-width: 769px) {
          width: 2.125rem;
          height: 2.125rem;
        }

        svg {
          width: 1.375rem;
          height: 1.375rem;
          pointer-events: none;

          @media (min-width: 769px) {
            width: 1.25rem;
            height: 1.25rem;
          }
        }
      }

      .strength {
        display: flex;
        align-items: baseline;

        &.weak {
          .strengthValue {
            color: var(--danger);
          }
        }

        &.medium {
          .strengthValue {
            color: var(--warning);
          }
        }

        &.strong {
          .strengthValue {
            color: var(--primary-600);
          }
        }
      }

      .strengthProgress {
        display: flex;
        column-gap: 0.25rem;

        &.weak {
          .strengthProgressLine {
            &:nth-child(1) {
              background-color: var(--danger);
            }
          }
        }

        &.medium {
          .strengthProgressLine {
            &:nth-child(1),
            &:nth-child(2) {
              background-color: var(--warning);
            }
          }
        }

        &.strong {
          .strengthProgressLine {
            background-color: var(--primary-600);
          }
        }

        .strengthProgressLine {
          flex: 1;
          height: 0.1875rem;
          border-radius: 0.125rem;
          background-color: var(--neutral-200);
        }
      }
    }

    .submit {
      width: 100%;
      height: 3rem;
      margin: 1.625rem 0 0;

      @media (min-width: 400px) {
        height: 3.25rem;
      }
    }

    .disclaimer {
      max-width: 23rem;
      margin: 0 auto 1rem;
      line-height: 1.375rem;
      text-align: center;

      a {
        color: var(--neutral-600);
        font-weight: 500;
        font-size: inherit;
        line-height: unset;
      }
    }
  }
}
